<template>
  <div class="comment-dots-wrapper" style="">
    <!-- <div
    v-for="comment in commentsWithStart"
    :key="comment.id"
    class="comment-dot"
    @mouseover="showPreviewWindow($event, comment)"
    @mouseleave="hidePreviewWindow()"
    :style="getCommentDotStyle(comment)"
    >
    </div>

    <div ref="previewWindow" class="commentPreview" :style="getPreviewWindowStyle">
      <div>
        <b v-if="hoveredComment">
          {{hoveredComment.createdby.name}}
        </b>
      </div>
      <div v-if="hoveredComment">
        wasd <br />
        wasd <br />
        wasd <br />
        wasd <br />
        {{hoveredComment.content}}
        {{hoveredComment.content}}
        {{hoveredComment.content}}
        {{hoveredComment.content}}
      </div>
    </div> -->

    <div style="width: 100%; height: 10px;">
      <v-tooltip location="top" open-delay="200"
      :aria-label="getCommentTooltipLabel(comment)"
      v-for="comment in commentsWithStart"
      :key="comment.id"
      >
        <template v-slot:activator="{ props }">
          <div

          v-bind="props"
          @click="commentClick(comment)"
          :style="getCommentDotStyle(comment)"
          class="comment-dot bg-primary"
          >
          </div>
        </template>
        <div>
          <div>
            <b>
              {{ toTimeMilliseconds(comment.start) }} -
              {{getCreatedBy(comment)}}
            </b>

          </div>
          <div style="white-space: pre-line; word-break: break-word;">
            {{comment.content}}
          </div>
        </div>
      </v-tooltip>
    </div>


  </div>
</template>

<script>
import { usePlayerStore } from '@/stores/PlayerStore.js'
import { toTimeMilliseconds } from '@/components/formatters.js';

export default {
  name: "CommentDots",
  props: {
    comments: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      // hoveredComment: null,
      // hoverEvent: null,
    };
  },
  methods: {
    toTimeMilliseconds,
    getCommentTooltipLabel(comment) {
      return `${this.toTimeMilliseconds(comment.start)} - ${this.getCreatedBy(comment)} ${comment.content}`;
    },
    // showPreviewWindow(event, comment) {
    //   this.hoveredComment = comment;
    //   this.hoverEvent = event;

    //   this.$refs.previewWindow.style.visibility = "unset";

    //   console.log("Event sender", event)
    //   console.log("ref preview", this.$refs.previewWindow.offsetWidth);
    // },
    // hidePreviewWindow() {
    //   this.hoveredComment = null;
    //   this.hoverEvent = null;

    //   this.$refs.previewWindow.style.visibility = "hidden";
    // },
    commentClick: function(comment) {
      const playerStore = usePlayerStore();
      playerStore.setSeekTimeEvent(comment.start);
    },
  },
  computed: {
    commentsWithStart() {
      return this.comments.filter(x => x.start !== null);
    },
    duration() {
      const playerStore = usePlayerStore();
      return playerStore.duration;
    },
    getCommentDotStyle() {
      return (comment) => {
        let leftOffset = (comment.start / this.duration) * 100
        let transformY = this.commentsWithStart.indexOf(comment) * 10;

        return {
          left: `${leftOffset}%`,
          transform: `translateY(-${transformY}px)`,
        };
      };
    },
    getCreatedBy: function() {
      return (comment) => {
        if (comment.createdby) {
          return `${comment.createdby.firstname} ${comment.createdby.lastname}`;
        }

        if (comment.email) {
          return comment.email;
        }
        return this.$t('common.deletedUser');
      }
    },
    // getPreviewWindowStyle() {
    //   if (!this.hoverEvent) {
    //     return {};
    //   }



    //   let previewBox = this.$refs.previewWindow.getBoundingClientRect()
    //   let left = this.hoverEvent.target.offsetLeft - (previewBox.width / 2);
    //   let top = this.hoverEvent.target.offsetTop - previewBox.height;


    //   console.log("this.hoverEvent.target.offsetTop", this.hoverEvent.target.offsetTop);
    //   console.log("previewBox", previewBox.height);

    //   return {
    //     left: `${left}px`,
    //     top: `${top}px`,
    //     // top: '-10px',
    //   }
    // },
  },
}
</script>

<style>
.comment-dots-wrapper {
  width: 100%;
  height: 10px;
  padding: 0px 8px;
}

.comment-dot {
  position: relative;
  width: 10px;
  height: 10px;
  /* float: left; */
  /* background-color: var(--primary); */
  border-radius: 5px;
  margin-left: -5px;
  /* left: 100%;  */
}

/* .commentPreview {
  visibility: hidden;
  clear: both;
  position: fixed;
  display: block;
  min-width: 200px;
  padding: 10px;

  border: 1px solid red;
  border-radius: 10px;
  z-index: 9;
} */

/* .v-theme--dark .commentPreview {
  background-color: rgba(30, 30, 30, 0.8);

}

.v-theme--light .commentPreview {
  background-color: rgba(255, 255, 255, 0.8);
} */

</style>
